import { watch } from 'vue';

export default defineNuxtPlugin(() => {
    const { $localStorage } = useNuxtApp();

    const profilo = useState('profilo', () => {
        const saved_foto_profilo = $localStorage.getItem('foto_profilo');
        return saved_foto_profilo &&
            String(saved_foto_profilo) !== 'null' &&
            String(saved_foto_profilo) !== 'undefined'
            ? saved_foto_profilo
            : '/logo-mini-notification.webp';
    });

    watch(
        profilo,
        (newValue) => {
            if (typeof newValue === 'string') $localStorage.setItem('foto_profilo', newValue);
            else if (typeof newValue === 'object')
                $localStorage.setItem('foto_profilo', newValue.foto_profilo);
        },
        {
            immediate: true,
            deep: true,
        }
    );
});
